import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Input } from "@myhealth-raccoon/components";
import { validation } from "@myhealth-raccoon/forms";
import classNames from "classnames";


export type UpdateEmailFormValues = {
    email: string;
};

type Props = {
    className?: string;
    onCancel?(): void;
    onSubmit(values: UpdateEmailFormValues): unknown;
    setIsDirty?(isDirty: boolean): void;
    isRequired?: boolean;
}

export function UpdateEmailForm({ className, onCancel, onSubmit, setIsDirty, isRequired }: Props) {

    const {
        handleSubmit,
        register,
        formState: { errors, isSubmitting, isDirty },
        watch
    } = useForm<UpdateEmailFormValues>({ defaultValues: { "email": "" }, mode: "onBlur" });

    useEffect(() => {
        setIsDirty?.(isDirty)
    }, [isDirty, setIsDirty]);

    return <form className={classNames(className, "group")} onSubmit={handleSubmit(onSubmit)}>
        <Input
            {...register("email", { validate: validation.composeValidators(validation.required("Enter a valid email"), validation.email("Enter a valid email")) })}
            fieldError={errors.email}
            id="email"
            type="email"
            placeholder='Please enter your email address'
            hint="For your security, we will send you a code to verify your email."
            autoFocus
            append={<button
                disabled={isSubmitting}
                type="submit"
                className='font-semibold text-primary-700 disabled:text-gray-600'
            >Get code</button>}
        />
        <div className="flex flex-row mt-5 gap-4">
            {(isDirty || (isRequired && !watch("email"))) && !isSubmitting && <span
                className={classNames("group-focus-within:hidden", {
                    "text-warning": !isRequired,
                    "text-error": isRequired
                })}
            >Please finish updating your email address.</span>}
            <div className='flex flex-row gap-3 w-fit ml-auto'>
                {onCancel && <button
                    type="button"
                    onClick={onCancel}
                    className='font-semibold'
                >Cancel</button>}
            </div>
        </div>
    </form>
}